import { Button } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router";

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (window.location.hostname.includes("kaylinackerman.com")) {
      navigate("home");
    }
  }, [navigate]);

  return (
    <>
      <Button
        onClick={() => {
          navigate("scion");
        }}
      >
        Go to Scion index
      </Button>
    </>
  );
};

export default Home;
